export default __webpack_public_path__ + "static/media/Helvetica.7f8d803f.woff";